import { TestAttributes } from '@va/types/component';
import Switch, { ReactSwitchProps } from 'react-switch';

type ToggleSwitchProps = {
  size?: 'small' | 'large';
} & TestAttributes &
  ReactSwitchProps;

const switchSizes = {
  small: {
    handleDiameter: 15,
    width: 30,
    height: 18,
  },
  large: {
    handleDiameter: 24,
    width: 48,
    height: 30,
  },
};

export const ToggleSwitch = ({ checked = false, size = 'large', ...props }: ToggleSwitchProps) => {
  // react-switch forwards unknown props to its visually hidden <input>, so test attributes are put on a wrapper instead.
  const { 'data-testid': dataTestId, ...switchProps } = props;

  const toggle = (
    <Switch
      offHandleColor='#FFFFFF'
      onHandleColor={'#FFFFFF'}
      offColor='#C3C3C3'
      onColor={window.POSITIVE_COLOR}
      checked={checked}
      checkedIcon={false}
      uncheckedIcon={false}
      {...switchSizes[size]}
      {...switchProps}
    />
  );

  if (!dataTestId) return toggle;

  return (
    <span data-testid={dataTestId} className='inline-flex items-center'>
      {toggle}
    </span>
  );
};
